export class Controller {

    /** @ngInject */
    constructor(RequestCenterService, $rootScope, $state) {
        this.RequestCenterService = RequestCenterService;
        this.$rootScope = $rootScope;
        this.$state = $state;
    }

    $onInit() {
    }

    accountChanged() {
    }

    companyChanged() {
        this.applications = null;
        this.selectedApplication = null;
        if(this.selectedCompany != null) {
            this.RequestCenterService.getApplications(this.selectedCompany.id)
            .then(applications => {
                this.applications = applications;
            });
            this.RequestCenterService.getAccounts(this.selectedCompany.id)
            .then(accounts => {
                this.accounts = accounts;
            });
        }
    }

    applicationChanged() {

    }

    submitDisabled() {
        if(!this.requestType) {
            return true;
        }
        if(this.requestType == 'HELPDESK' || this.requestType == 'APPROVAL_FORM') {
            return !(this.note && this.note.length > 0 && this.selectedCompany);
        } else {
            return !(this.note && this.note.length > 0 && this.selectedCompany && this.selectedApplication && this.selectedAccount);
        }
    }

    submit() {
        let requestDto = {
            companyId: this.selectedCompany.id,
            type: this.requestType,
            note: this.note
        }
        if(this.requestType == 'APP_ACCESS') {
            requestDto.applicationId = this.selectedApplication.id;
            requestDto.companyUserAccountId = this.selectedAccount.id;
        }
        this.RequestCenterService
            .createRequest(requestDto)
            .then(() => this.$state.go('^', {}, {reload: '^'}))
    }

	goBack() {
		var goToState = this.$rootScope.transition.from();
		var theState = goToState.name;
		if (theState === "") {
			theState = goToState.url;
		}
		this.$state.go(theState);
	}
}



// WEBPACK FOOTER //
// ./src/portal/states/user/request-center/requests/create/create-access-request.controller.js